import { Component, OnInit, inject } from '@angular/core';
import { RouterModule } from '@angular/router';
import { TranslocoModule } from '@jsverse/transloco';
import { BsDropdownModule } from 'ngx-bootstrap/dropdown';
import { Notification } from '../notification.model';
import { NotificationService } from '../notification.service';
import { NotificationTargetService } from '../notification-target.service';

/**
 * The bell in the main navigation: the count of the reader's unread
 * notifications, the newest few, and the way to all of them at
 * `/notifications`. It loads them itself when it appears, so a navigation
 * shows it only for a signed-in reader:
 *
 * ```html
 * @if (user()) {
 *   <li multisiteNotificationBell></li>
 * }
 * ```
 *
 * An item in the navigation's list, so it is an attribute on the `<li>`.
 */
@Component({
  selector: 'li[multisiteNotificationBell]',
  templateUrl: './notification-bell.component.html',
  imports: [RouterModule, TranslocoModule, BsDropdownModule],
  host: { class: 'nav-item dropdown' },
})
export class NotificationBellComponent implements OnInit {
  private notificationService = inject(NotificationService);
  private targetService = inject(NotificationTargetService);

  get notifications(): Notification[] {
    return this.notificationService.topThreeUnreadNotifications;
  }

  /** All the reader's unread notifications, of which `notifications` are the newest few. */
  get unreadCount(): number {
    return this.notificationService.unreadCount;
  }

  ngOnInit(): void {
    this.notificationService.loadUnreadNotifications().subscribe({ error: () => undefined });
  }

  open(notification: Notification): void {
    this.targetService.open(notification).subscribe({ error: () => undefined });
  }
}
